module.exports = __webpack_public_path__ + "static/media/vector.e6c09bd1.png";